import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { KindeAngularService } from 'kinde-angular';
import { map, of, switchMap, take } from 'rxjs';

import { UserPermission } from '../models/user-permission.enum';
import { PermissionService } from '../services/permission.service';

export const CheckLoggedInGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(KindeAngularService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const defaultRoutes: Map<UserPermission, string> | undefined = route.data.defaultRoutes;
  const unauthorizedRoute: string | undefined = route.data.unauthorizedRoute;
  const postLoginUrl = sessionStorage.getItem('post_login_url');

  return authService.isAuthenticated$.pipe(
    take(1),
    switchMap((isAuthenticated) => {
      if (!isAuthenticated) {
        return of(true);
      }

      return permissionService.permissions$.pipe(
        take(1),
        map((permissions) => {
          if (postLoginUrl) {
            sessionStorage.removeItem('post_login_url');
            return router.parseUrl(postLoginUrl);
          }

          for (const [permission, routePath] of defaultRoutes ?? []) {
            if (permissions.includes(permission)) {
              return router.parseUrl(routePath);
            }
          }

          if (unauthorizedRoute) {
            return router.parseUrl(unauthorizedRoute);
          }

          return false;
        })
      );
    })
  );
};
